export default {"src":"/_next/static/media/cross.e8e1be38.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};